//var $ = $.noConflict(true);
// $(document).ready(function(){
  //------for close button of banner welcome message------//
  $(document).on('click','.welcome-msg-close',function(){
      $('.headlinee').fadeOut();
      localStorage.setItem('welcome-msg-close-status', 1);
  });
  
  if( getCookie("cc") && getCookie("response") ){
    //console.log('is in cookie');
    var cc = getCookie("cc");
    var response = JSON.parse( getCookie("response") );
    setContent(cc,response);
  } else {
    var ip = '';
    $.getJSON("https://api.ipify.org/?format=json", function(e) {
        ip = e.ip;
        var urlParams = new URLSearchParams(window.location.search);
        // searching for ip query param
        if (urlParams.has('ip')) { 
          ip = urlParams.get('ip');
        }
        if((ip != '')){
          //console.log('The ip is:' + ip);
          $.getJSON('https://ipapi.co/' + ip + '/json', function(response){
              if(isDomainList(response.country) >= 0){
                //console.log('is domain');
                setContent(response.country.toLowerCase(),response);
              }else{
                //console.log('not is domain');
                setContent('int',response);
              }
          });
        }else{
          $('.headline').html($('.headlineval').val());
        }
    });
  } 
// });

function setContent(cc,response){
  return true;
   var currencySymbol = matchCurrency(response.currency);
   console.log('The cc ist: set content' + cc);
   if((cc == 'au') && (window.location.href.indexOf('aud.') != -1 || window.location.href.indexOf('au.') != -1)){
        changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
   }else if((cc == 'fr') || window.location.href.indexOf('.fr') != -1){
        changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
   }else if(window.location.href.indexOf(cc + '.') != -1){
     //---if country code from ip which is cc and url has same countrycode at first like cc.bathmatedirect.com then showing placeholder content--//
        changeLanguagePlaceholderMessage(response.country);
        $('.placeholdercont').css('display','block');
   }else{
      changeLanguageWelcomeMessage(response.country);
      switch(cc) {
        case 'gb':
          cc = 'uk';
          break;
        case 'gr':
          cc = 'el';
          break;
        case 'jp':
          cc = 'ja';
          break;
        case 'cn':
          cc = 'zh';
          break;
        case 'kp':
        case 'kr':
          cc = 'ko';
          break;
        default:
          // code block
      }
     if(typeof trans_id == 'undefined'){
       	var trans_id = '';
     }
     if(cc == 'fr'){
      $('.visit').attr('href','https://bathmatedirect.fr'+trans_id).text('bathmatedirect.fr');
     }else{
      $('.visit').attr('href','https://' + cc + '.bathmatedirect.com'+trans_id).text(cc + '.bathmatedirect.com');
     }
      $('.currencyContent').text(response.currency+' ('+currencySymbol+')');
      $('.welcome-banner').css('display','block');
     }
  
     if((localStorage.getItem('welcome-msg-close-status')) && (localStorage.getItem('welcome-msg-close-status') == 1)){
       $('.headlinee').fadeOut();
     }else{ setTimeout(function(){ $('.headlinee').fadeIn(); }, 1000); }
      setCookie("cc", cc, 30);
      setCookie("response", JSON.stringify(response), 30);
}
  
function isEU(countrycode) {
var eu_countrycodes = new Array(
'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL',
'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK','GR','JP','CN'
);
return($.inArray(countrycode, eu_countrycodes));
}
  
function isDomainList(countrycode) {
//console.log('countrycode',countrycode);
var domain_list_countrycodes = new Array(
'UK','GB','US','CA','AU','EU','IL','NO','EL','FI','DK','SE','IS',
'ES','CZ','PL','PT','RU','TH','KO','KP','KR','AR','EL','JA','ZH','FR','DE',
'IT','NL','GR','JP','CN'
);
return($.inArray(countrycode, domain_list_countrycodes));
}
  
function matchCurrency(CurrencyCode){
  var currencyCode = $.trim(CurrencyCode);
   //var domain_list_countryCodes = {AED: "", AFN: "", ALL: "Lek", ANG: "ƒ", AOA: "", ARS: "$", AUD: "$", AWG: "ƒ", AZN: "ман", BAM: "KM", BBD: "$", BDT: "", BGN: "лв", BHD: "", BIF: "", BMD: "$", BND: "$", BOB: "$b", BRL: "R$", BSD: "$", BWP: "P", BYR: "p.", BZD: "BZ$", CAD: "$", CDF: "", CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "₱", CVE: "", CZK: "Kč", DJF: "", DKK: "kr", DOP: "RD$", DZD: "", EEK: "", EGP: "£", ERN: "", ETB: "", EUR: "€", FJD: "$", FKP: "£", GBP: "£", GEL: "", GHS: "", GIP: "£", GMD: "", GNF: "", GTQ: "Q", GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HTG: "", HUF: "Ft", IDR: "Rp", ILS: "₪", INR: "₹", IQD: "", IRR: "", ISK: "kr", JMD: "J$", JOD: "", JPY: "¥", KES: "", KGS: "лв", KHR: "៛", KMF: "", KPW: "₩", KRW: "₩", KWD: "", KYD: "$", KZT: "лв", LAK: "₭", LBP: "£", LKR: "₨", LRD: "$", LTL: "Lt", LVL: "Ls", LYD: "", MAD: "", MDL: "", MGA: "", MKD: "ден", MMK: "", MNT: "₮", MOP: "", MRO: "", MUR: "₨", MVR: "", MWK: "", MXN: "$", MYR: "RM", MZN: "MT", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", PAB: "B/.", PEN: "S/.", PHP: "Php", PKR: "₨", PLN: "zł", PYG: "Gs", RON: "lei", RSD: "Дин.", RUB: "руб", SBD: "$", SCR: "₨", SEK: "kr", SGD: "$", SHP: "£", SOS: "S", SRD: "$", SVC: "$", SYP: "£", THB: "฿", TRY: "TL", TTD: "TT$", TWD: "NT$", UAH: "₴", USD: "$", UYU: "$U", UZS: "лв", VEF: "Bs", VND: "₫", XCD: "$", ZAR: "R"};
  var domain_list_countryCodes = {ALL: "Lek", ANG: "ƒ", ARS: "$", AUD: "$", AWG: "ƒ", AZN: "ман", BAM: "KM", BBD: "$", BDT: "৳", BGN: "лв", BIF: "FBu", BMD: "$", BND: "$", BOB: "$b", BRL: "R$", BSD: "$", BWP: "P", BYR: "p.", BZD: "BZ$", CAD: "$", CDF: "FC", CHF: "CHF", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUP: "₱", CVE: "$", CZK: "Kč", DJF: "Fdj", DKK: "kr", DOP: "RD$", EEK: "kr", EGP: "£", ERN: "Nfk", ETB: "Br", EUR: "€", FJD: "$", FKP: "£", GBP: "£", GEL: "ლ", GHS: "GH₵", GIP: "£", GMD: "D", GNF: "FG", GTQ: "Q", GYD: "$", HKD: "$", HNL: "L", HRK: "kn", HUF: "Ft", IDR: "Rp", ILS: "₪", INR: "₹", ISK: "kr", JMD: "J$", JPY: "¥", KES: "/-", KGS: "лв", KHR: "៛", KPW: "₩", KRW: "₩", KWD: "KD", KYD: "$", KZT: "лв", LAK: "₭", LBP: "£", LKR: "₨", LRD: "$", LTL: "Lt", LVL: "Ls", MKD: "ден", MNT: "₮", MUR: "₨", MXN: "$", MYR: "RM", MZN: "MT", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "₨", NZD: "$", PAB: "B/.", PEN: "S/.", PHP: "Php", PKR: "₨", PLN: "zł", PYG: "Gs", RON: "lei", RSD: "Дин.", RUB: "руб", SBD: "$", SCR: "₨", SEK: "kr", SGD: "$", SHP: "£", SOS: "S", SRD: "$", SVC: "$", SYP: "£", THB: "฿", TRY: "TL", TTD: "TT$", TWD: "NT$", UAH: "₴", USD: "$", UYU: "$U", UZS: "лв", VEF: "Bs", VND: "₫", XCD: "$", ZAR: "R"};
  if(domain_list_countryCodes. hasOwnProperty(currencyCode)){
    return domain_list_countryCodes[currencyCode];
  }
  else{
    return ' ';
  }
//   console.log('USD',domain_list_countrycodes.USD);
}
  
function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
function changeLanguageWelcomeMessage(countryCode){
  //console.log('in changeLanguageWelcomeMessage'+ countryCode);
  var countryCode = $.trim(countryCode);
  var lang_list_countryCodes = {
    FR: "Cliquez ici pour visiter urlXXXX pour voir les options de livraison à votre emplacement et les options de paiement dans curXXXX",
    SE: "Klicka här för att besöka urlXXXX för att se leveransalternativ till din plats och betalningsalternativ i curXXXX",
    DE: "Klicken Sie hier, um urlXXXX zu besuchen und die Versandoptionen zu Ihrem Standort sowie die Zahlungsoptionen in curXXXX anzuzeigen",
    AR: "انقر هنا لزيارة urlXXXX للاطلاع على خيارات الشحن لموقعك وخيارات الدفع في curXXXX",
    ZH: "点击此处访问urlXXXX，以查看您所在位置的送货方式以及curXXXX中的付款方式",
    CZ: "Kliknutím sem navštívíte adresu urlXXXX, kde zobrazíte možnosti dopravy do vaší oblasti a možnosti platby v curXXXX",
    ES: "Haga clic aquí para visitar urlXXXX para ver las opciones de envío a su ubicación y las opciones de pago en curXXXX",
    EL: "Κάντε κλικ εδώ για να επισκεφθείτε το urlXXXX για να δείτε τις επιλογές αποστολής στην τοποθεσία σας και τις επιλογές πληρωμής στο curXXXX",
    IT: "Fai clic qui per visitare urlXXXX e vedere le opzioni di spedizione per la tua posizione e le opzioni di pagamento in curXXXX",
    JP: "ここをクリックしてurlXXXXにアクセスし、お住まいの地域への配送オプションとcurXXXXの支払いオプションを確認してください",
    KO: "urlXXXX를 방문하여 현재 위치에 대한 배송 옵션과 curXXXX의 결제 옵션을 보려면 여기를 클릭하십시오.",
    NL: "Klik hier om urlXXXX te bezoeken om de verzendopties naar uw locatie en betalingsopties in curXXXX te zien",
    PL: "Kliknij tutaj, aby odwiedzić adres urlXXXX, aby zobaczyć opcje wysyłki do swojej lokalizacji i opcje płatności w curXXXX",
    PT: "Clique aqui para visitar urlXXXX para ver as opções de envio para o seu local e as opções de pagamento em curXXXX",
    RU: "Нажмите здесь, чтобы перейти по адресу urlXXXX, чтобы просмотреть варианты доставки до вашего местоположения и способы оплаты в curXXXX",
    TH: "คลิกที่นี่เพื่อไปที่ urlXXXX เพื่อดูตัวเลือกการจัดส่งไปยังสถานที่ของคุณและตัวเลือกการชำระเงินใน curXXXX"
  };
  if(lang_list_countryCodes.hasOwnProperty(countryCode)){
    var bannerContent = lang_list_countryCodes[countryCode];
  }
  else{
    var bannerContent = "Click here to visit urlXXXX to see shipping options to your location and payment options in curXXXX";
  }
   bannerContent = bannerContent.replace("urlXXXX", "<u><a class='visit' href=''></a></u>");
   bannerContent = bannerContent.replace("curXXXX", "<span class='currencyContent'></span>");
   //console.log('bannerContent: '+bannerContent);
   $('.welcome-banner').html(bannerContent + '<div class="welcome-msg-close"></div>');
   return;
}
  
function changeLanguagePlaceholderMessage(countryCode){
  //console.log('in changeLanguagePlaceholderMessage' + countryCode);
  var countryCode = $.trim(countryCode);
  var lang_list_countryCodes = {
    FR: "Comprend une garantie de remboursement de 60 jours à 100% sur toutes les commandes de pompe hydraulique!",
    SE: "Inkluderar en 60-dagars 100% pengarna-tillbaka-garanti på alla Hydropump-beställningar!",
    DE: "Beinhaltet eine 60-tägige 100% Geld-zurück-Garantie auf alle Hydropumpenbestellungen!",
    AR: "يتضمن ضمان استرداد الأموال بنسبة 100٪ لمدة 60 يومًا على جميع طلبات Hydropump!",
    ZH: "包括所有Hydropump订单的60天100％退款保证！",
    CZ: "Zahrnuje 60denní 100% záruku vrácení peněz u všech objednávek Hydropump!",
    ES: "Incluye una garantía de devolución del 100% del dinero de 60 días en todos los pedidos de Hydropump.",
    EL: "Περιλαμβάνει εγγύηση επιστροφής χρημάτων 100% 60 ημερών σε όλες τις παραγγελίες Hydropump!",
    IT: "Include una garanzia di rimborso del 100% di 60 giorni su tutti gli ordini di Hydropump!",
    JP: "すべてのHydropump注文に60日間の100％返金保証が含まれています！",
    KO: "모든 Hydropump 주문에 대해 60 일 100 % 환불 보장이 포함됩니다!",
    NL: "Inclusief een 100% geld-terug-garantie van 60 dagen op alle hydropompbestellingen!",
    PL: "Obejmuje 60-dniową gwarancję 100% zwrotu pieniędzy na wszystkie zamówienia Hydropump!",
    PT: "Inclui garantia de 100% de reembolso de 60 dias em todos os pedidos do Hydropump!",
    RU: "Включает 60-дневную 100% гарантию возврата денег на все заказы на гидронасосы!",
    TH: "รวมการรับประกันคืนเงิน 100% 60 วันสำหรับคำสั่งซื้อ Hydropump ทั้งหมด!"
  };
  if(lang_list_countryCodes.hasOwnProperty(countryCode)){
    var placeholderContent = lang_list_countryCodes[countryCode];
  }
  else{
    var placeholderContent = "Includes a 60-Day 100% Money-Back Guarantee on All Hydropump Orders!";
  }
  $('.placeholdercont').html(placeholderContent + '<div class="welcome-msg-close"></div>');
  return;
}